/* eslint-disable prettier/prettier */
import { createRouter, createWebHistory } from "vue-router";
import Container from "@/views/Container.vue";
import DashboardLayout from "../views/DashboardLayout.vue";
import Dashboard from "../views/Dashboard.vue";
import Tables from "../views/Tables.vue";
import Billing from "../views/Billing.vue";
import VirtualReality from "../views/VirtualReality.vue";
import RTL from "../views/Rtl.vue";
import Profile from "../views/Profile.vue";
import Auth from "../views/auth/Auth.vue";
import Verification from "../views/auth/Verification.vue";
import Signup from "../views/auth/Signup.vue";
import Signin from "../views/auth/Signin.vue";
import ForgotPassword from "../views/auth/ForgotPassword.vue";
import MasterDataPegawai from "../views/masterdata/employee/MasterDataEmployees.vue";
import MasterDataPegawaiForm from "../views/masterdata/employee/MasterDataEmployeeForm.vue";
import MasterDataPegawaiDetail from "../views/masterdata/employee/MasterDataEmployeeDetail.vue";

import MasterDataKpi from "../views/masterdata/kpi/MasterDataKpis.vue";
import MasterDataKpiForm from "../views/masterdata/kpi/MasterDataKpiForm.vue";

import MasterDataKpiPeriodeForm from "../views/masterdata/kpi/periode/MasterDataKpiPeriodeForm.vue";
import MasterDataKpiPeriode from "../views/masterdata/kpi/periode/MasterDataKpiPeriode.vue";

import MasterDataKpiCompetenceForm from "../views/masterdata/kpi/competence/MasterDataKpiCompetenceForm.vue";
import MasterDataKpiCompetence from "../views/masterdata/kpi/competence/MasterDataKpiCompetence.vue";

import MasterDataPenguranganForm from "../views/masterdata/pengurangan/MasterDataPenguranganForm.vue";
import MasterDataPengurangan from "../views/masterdata/pengurangan/MasterDataPengurangan.vue";

import User from "../views/user/Users.vue";
import UserAktivitas from "../views/user/UsersAktivitas.vue";
import UserForm from "../views/user/UserForm.vue";
import UserSingle from "../views/user/UserSingle.vue";

import MasterDataUserJabatanForm from "../views/masterdata/user/jabatan/MasterDataUserJabatanForm.vue";
import MasterDataUserJabatan from "../views/masterdata/user/jabatan/MasterDataUserJabatan.vue";

import MasterDataUserUnitKerjaForm from "../views/masterdata/user/unitkerja/MasterDataUserUnitKerjaForm.vue";
import MasterDataUserUnitKerja from "../views/masterdata/user/unitkerja/MasterDataUserUnitKerja.vue";

import MasterDataKpiAspekKpiForm from "../views/masterdata/kpi/aspekkpi/MasterDataKpiAspekKpiForm.vue";
import MasterDataKpiAspekKpi from "../views/masterdata/kpi/aspekkpi/MasterDataKpiAspekKpi.vue";

import MasterDataHakAksesForm from "../views/masterdata/hakakses/MasterDataHakAksesForm.vue";
import MasterDataHakAkses from "../views/masterdata/hakakses/MasterDataHakAkses.vue";

import Menu from "../views/menu/Menu.vue";
import MenuForm from "../views/menu/MenuForm.vue";

const routes = [
  {
    path: "/auth",
    component: Auth,
    redirect: () => {
      return { name: "Signin" }
    },
    children: [
      {
        path: "signin",
        name: "Signin",
        meta: {
          label: "Sing In",
          title: "Sign In"
        },
        component: Signin,
      },
      {
        path: "signup",
        name: "Signup",
        meta: {
          label: "Sign Up",
          title: "Sign Up"
        },
        component: Signup,
      },
      {
        path: "forgotpassword",
        name: "Forgot Password",
        meta: {
          label: "Forgot Password",
          title: "Forgot Password"
        },
        component: ForgotPassword,
      },
      {
        path: "verification/:token",
        name: "Verification",
        meta: {
          label: "Verification",
          title: "Verification"
        },
        component: Verification,
      },
    ],
  },
  {
    path: "/",
    name: "/",
    meta: {
      title: "Dashboard",
      label: "Dashboard Layout",
    },
    component: DashboardLayout,
    redirect: () => {
      return { name: "Signin" }
    },
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        meta: {
          label: "Dashboard",
        },
        component: Dashboard,
      },
      {
        path: "master-data-kpi",
        meta: {
          title: "Master Data KPI",
          label: "Master Data KPI",
          breadcrumb: "Master Data Kpi",
        },
        component: Container,
        redirect: () => {
          return { name: "Master Data Kpi" };
        },
        children: [
          {
            path: "",
            component: Container,
            meta: {
              title: "Master Data KPI"
            },
            redirect: () => {
              return { name: "Master Data Kpi"};
            },
            children: [
              {
                path: "",
                name: "Master Data Kpi",
                component: MasterDataKpi,
              },
              {
                path: "create",
                name: "Master Data Kpi Create",
                component: MasterDataKpiForm,
              },
              {
                path: ":id",
                name: "Master Data Kpi Edit",
                component: MasterDataKpiForm,
              },
            ],
          },
          {
            path: "periode-kpi",
            component: Container,
            meta: {
              title: "Periode KPI",
              breadcrumb: "Periode KPI",
            },
            children: [
              {
                path: "",
                name: "Periode KPI",
                meta: {
                  title: "Periode KPI",
                  module: "Master Data KPI",
                },
                component: MasterDataKpiPeriode,
              },
              {
                path: "create",
                name: "Create Periode KPI",
                meta: {
                  title: "Tambah Periode KPI",
                  breadcrumb: "Create Periode KPI",
                  module: "Master Data KPI",
                },
                component: MasterDataKpiPeriodeForm,
              },
              {
                path: ":id",
                name: "Edit Periode KPI",
                meta: {
                  title: "Ubah Periode KPI",
                  module: "Master Data KPI",
                },
                component: MasterDataKpiPeriodeForm,
              },
            ]
          },
          {
            path: "aspek-kpi",
            meta: {
              title: "Aspek KPI"
            },
            component: Container,
            children: [
              {
                path: "",
                name: "Aspek KPI",
                meta: {
                  title: "Aspek KPI",
                  module: "Master Data KPI",
                },
                component: MasterDataKpiAspekKpi,
              },
              {
                path: "create",
                name: "Create Aspek KPI",
                meta: {
                  title: "Tambah Aspek KPI",
                  module: "Master Data KPI",
                },
                component: MasterDataKpiAspekKpiForm,
              },
              {
                path: ":id",
                name: "Update Aspek KPI",
                meta: {
                  title: "Ubah Aspek KPI",
                  module: "Master Data KPI",
                },
                component: MasterDataKpiAspekKpiForm,
              },
            ]
          },
          {
            path: "penilaian-kinerja",
            meta: {
              title: "Penilaian Kinerja"
            },
            component: Container,
            children: [
              {
                path: "",
                name: "Penilaian Kinerja",
                meta: {
                  title: "Penilaian Kinerja KPI",
                },
                component: () => import('@/views/masterdata/kpi/penilaian-kinerja/MasterDataKpiPenilaianKinerja.vue'),
              },
              {
                path: "create",
                name: "Create Penilaian Kinerja",
                meta: {
                  title: "Tambah Penilaian Kinerja KPI",
                },
                component: () => import('@/views/masterdata/kpi/penilaian-kinerja/MasterDataKpiPenilaianKinerjaForm.vue'),
              },
              {
                path: ":id",
                name: "Update Penilaian Kinerja",
                meta: {
                  title: "Ubah Penilaian Kinerja KPI",
                },
                component: () => import('@/views/masterdata/kpi/penilaian-kinerja/MasterDataKpiPenilaianKinerjaForm.vue'),
              },
              {
                // path: 'detail/:employee_id/:realization_id/:submission_status/:periode_id',
                path: 'detail/:id',
                name: 'Detail Penilaian Kinerja',
                meta: {
                  title: "Detail Penilaian Kinerja KPI",
                },
                component: () => import('@/views/masterdata/kpi/penilaian-kinerja/MasterDataKpiPenilaianKinerjaDetail.vue'),
              },
            ]
          },
          {
            path: "kompetensi",
            component: Container,
            meta: {
              title: "Kompetensi"
            },
            children: [
              {
                path: "",
                name: "Competencies",
                meta: {
                  title: "Kompetensi",
                  module: "Master Data KPI",
                },
                component: MasterDataKpiCompetence
              },
              {
                path: "create",
                name: "Create Competencies",
                meta: {
                  title: "Tambah Kompetensi",
                  module: "Master Data KPI",
                },
                component: MasterDataKpiCompetenceForm
              },
              {
                path: ":id",
                name: "Update Competencies",
                meta: {
                  title: "Ubah Kompetensi",
                  module: "Master Data KPI",
                },
                component: MasterDataKpiCompetenceForm
              },
            ],
          },
          {
            path: "pengurangan",
            meta: {
              title: "Pengurangan"
            },
            component: Container,
            children: [
              {
                path: "",
                name: "Pengurangan",
                meta: {
                  title: "Pengurangan",
                  module: "Master Data KPI",
                },
                component: MasterDataPengurangan
              },
              {
                path: "create",
                name: "Create Pengurangan",
                meta: {
                  title: "Tambah Pengurangan",
                  module: "Master Data KPI",
                },
                component: MasterDataPenguranganForm
              },
              {
                path: ":id",
                name: "Update Pengurangan",
                meta: {
                  title: "Ubah Pengurangan",
                  module: "Master Data KPI",
                },
                component: MasterDataPenguranganForm
              },
            ],
          },
          {
            path: "target-konsolidasi",
            meta: {
              title: "Target Konsolidasi"
            },
            component: Container,
            children: [
              {
                path: "",
                name: "Target Konsolidasi",
                meta: {
                  title: "Target Konsolidasi",
                },
                component: () => import('@/views/masterdata/kpi/target-konsolidasi/MasterDataKpiTargetKonsolidasi.vue'),
              },
              {
                path: "create",
                name: "Create Target Konsolidasi",
                meta: {
                  title: "Tambah Target Konsolidasi",
                },
                component: () => import('@/views/masterdata/kpi/target-konsolidasi/MasterDataKpiTargetKonsolidasiForm.vue'),
              },
              {
                path: ":id",
                name: "Update Target Konsolidasi",
                meta: {
                  title: "Ubah Target Konsolidasi",
                },
                component: () => import('@/views/masterdata/kpi/target-konsolidasi/MasterDataKpiTargetKonsolidasiForm.vue'),
              },
              {
                path: ":id/detail",
                name: "Detail Target Konsolidasi",
                meta: {
                  title: "Detail Target Konsolidasi",
                },
                component: () => import('@/views/masterdata/kpi/target-konsolidasi/MasterDataKpiTargetKonsolidasiDetail.vue'),
              },
            ]
          },
        ]
      },
      {
        path: "master-data-user",
        meta: {
          title: "Master Data User"
        },
        component: Container,
        redirect: () => {
          return { name: "Jabatan" };
        },
        children: [
          {
            path: "jabatan",
            meta: {
              title: "Jabatan"
            },
            component: Container,
            redirect: () => {
              return {
                name: "Jabatan",
              };
            },
            children: [
              {
                path: "",
                name: "Jabatan",
                meta: {
                  title: "Jabatan",
                  description: "",
                },
                component: MasterDataUserJabatan,
              },
              {
                path: "create",
                name: "Create Jabatan",
                meta: {
                  title: "Tambah Jabatan",
                },
                component: MasterDataUserJabatanForm,
              },
              {
                path: ":id",
                name: "Update Jabatan",
                meta: {
                  title: "Edit Jabatan",
                },
                component: MasterDataUserJabatanForm,
              },
            ]
          },
          {
            path: "unit-kerja",
            meta: {
              title: "Unit Kerja"
            },
            component: Container,
            redirect: () => {
              return {
                name: "Unit Kerja",
              };
            },
            children: [
              {
                path: "",
                name: "Unit Kerja",
                meta: {
                  title: "Unit Kerja",
                },
                component: MasterDataUserUnitKerja,
              },
              {
                path: "create",
                name: "Create Unit Kerja",
                meta: {
                  title: "Tambah Unit Kerja",
                },
                component: MasterDataUserUnitKerjaForm,
              },
              {
                path: ":id",
                name: "Update Unit Kerja",
                meta: {
                  title: "Ubah Unit Kerja",
                },
                component: MasterDataUserUnitKerjaForm,
              },
            ]
          },
          {
            path: "struktur-unit-kerja",
            name: "Struktur Unit Kerja",
            meta: {
              title: "Struktur Unit Kerja",
            },
            component: () => import('@/views/masterdata/user/struktur-unit-kerja/MasterDataUserStrukturUnitKerja.vue'),
          },
        ]
      },
      {
        path: 'manajemen-kpi',
        // component: Container,
        meta: {
          title: "Manajemen KPI"
        },
        component: () => import('@/views/Container.vue'),
        redirect: () => {
          return { name: 'Assignment KPI Pegawai' }
        },
        children: [
          {
            path: 'assignment-kpi-pegawai',
            meta: {
              title: "Manajemen KPI Pegawai"
            },
            component: () => import('@/views/Container.vue'),
            children: [
              {
                path: '',
                name: "Assignment KPI Pegawai",
                component: () => import('@/views/management-kpi/assignment/AssignmentKpi.vue'),
              },
              {
                path: 'create',
                name: "Create Assignment KPI Pegawai",
                component: () => import('@/views/management-kpi/assignment/AssignmentKpiForm.vue'),
              },
              {
                path: 'detail/:id/:periode_id/:status',
                name: "Detail Assignment KPI Pegawai",
                component: () => import('@/views/management-kpi/assignment/AssignmentKpiForm.vue'),
              },
            ],
          },
          {
            path: 'realisasi-kinerja-kpi',
            name: 'Realisasi Kinerja KPI',
            component: () => import('@/views/management-kpi/realisasi-kinerja-kpi/RealisasiKinerjaKpi.vue'),
          },
          {
            path: 'penilaian-kpi',
            // name: '',
            component: () => import('@/views/Container.vue'),
            children: [
              {
                path: '',
                name: "Penilaian KPI",
                component: () => import('@/views/management-kpi/penilaian-kpi/PenilaianKpi.vue'),
              },
              {
                path: 'detail/:employee_id/:realization_id/:submission_status/:periode_id',
                name: 'Penilaian KPI Detail',
                component: () => import('@/views/management-kpi/penilaian-kpi/PenilaianKpiDetail.vue'),
              },
              {
                path: 'update/:employee_id/:realization_id/:submission_status/:periode_id',
                name: 'Penilaian KPI Update',
                component: () => import('@/views/management-kpi/penilaian-kpi/PenilaianKpiUpdate.vue'),
              },
            ],
          },
          {
            path: 'monitoring-hasil',
            // name: 'Monitoring Hasil',
            component: () => import('@/views/Container.vue'),
            children: [
              {
                path: '',
                name: 'Monitoring Hasil',
                component: () => import('@/views/management-kpi/monitoring-hasil/MonitoringHasil.vue'),
              },
              {
                path: 'detail/:realization_id/:periode_id',
                name: 'Monitoring Hasil Detail',
                component: () => import('@/views/management-kpi/monitoring-hasil/MonitoringHasilDetail.vue'),
              },
            ],
          },
          {
            path: 'tracking-status',
            // name: '',
            component: () => import('@/views/Container.vue'),
            children: [
              {
                path: '',
                name: "Tracking Status",
                component: () => import('@/views/management-kpi/tracking-status/TrackingStatus.vue'),
              },
              {
                path: 'detail/:realization_id/:periode_id/:status',
                name: 'Tracking Status Detail',
                component: () => import('@/views/management-kpi/tracking-status/TrackingStatusDetail.vue'),
              },
              {
                path: 'update/:realization_id/:periode_id/:status',
                name: 'Tracking Status Update KPI',
                component: () => import('@/views/management-kpi/tracking-status/TrackingStatusUpdate.vue'),
              },
            ],
          },
          {
            path: 'koreksi-hasil-penilaian',
            // name: '',
            component: () => import('@/views/Container.vue'),
            children: [
              {
                path: '',
                name: "Koreksi Hasil Penilaian",
                component: () => import('@/views/management-kpi/koreksi-hasil-penilaian/KoreksiHasilPenilaian.vue'),
              },
              {
                path: 'detail/:periode_id/:employee_id/:realization_id/:status_koreksi/:correction_id?',
                name: 'Koreksi Hasil Penilaian Detail',
                component: () => import('@/views/management-kpi/koreksi-hasil-penilaian/KoreksiHasilPenilaianDetail.vue'),
              },
            ],
          },
          {
            path: 'pengajuan-koreksi',
            // name: '',
            component: () => import('@/views/Container.vue'),
            children: [
              {
                path: '',
                name: "Pengajuan Koreksi",
                component: () => import('@/views/management-kpi/pengajuan-koreksi/PengajuanKoreksi.vue'),
              },
              {
                path: 'detail/:periode_id/:employee_id/:realization_id/:status_koreksi/:correction_id?',
                name: 'Pengajuan Koreksi Detail',
                component: () => import('@/views/management-kpi/pengajuan-koreksi/PengajuanKoreksiDetail.vue'),
              },
            ],
          },
          {
            path: "usulan-kpi",
            meta: {
              title: "Usulan KPI"
            },
            component: Container,
            children: [
              {
                path: "",
                name: "Usulan Kpi",
                meta: {
                  title: "Usulan KPI",
                },
                component: () => import('@/views/masterdata/kpi/usulan/MasterDataKpiUsulan.vue'),
              },
              {
                path: "detail/:employee_id/:periode_id",
                name: "Detail Usulan Kpi",
                meta: {
                  title: "Detail Usulan KPI",
                },
                component: () => import('@/views/masterdata/kpi/usulan/MasterDataKpiUsulanDetail.vue'),
              },
            ]
          },
        ],
      },

      {
        path: "manajemen-hak-akses",
        component: Container,
        meta: {
          title: "Manajemen Hak Akses"
        },
        redirect: () => {
          return { name: "Hak Akses" };
        },
        children: [
          {
            path: "",
            name: "Hak Akses",
            meta: {
              title: "Daftar Hak Akses",
              description: "",
              module: "Manajemen Hak Akses",
            },
            component: MasterDataHakAkses,
          },
          {
            path: "create",
            name: "Hak Akses Create",
            meta: {
              title: "Tambah Hak Akses",
              description: "",
              module: "Manajemen Hak Akses",
            },
            component: MasterDataHakAksesForm,
          },
          {
            path: ":id",
            name: "Hak Akses Edit",
            meta: {
              title: "Ubah Hak Akses",
              description: "",
              module: "Manajemen Hak Akses",
            },
            component: MasterDataHakAksesForm,
          },
        ],
      },
      {
        path: "manajemen-pegawai",
        component: Container,
        meta: {
          title: "Manajemen Pegawai"
        },
        redirect: () => {
          return { name: "Manajemen Pegawai" }
        },
        children: [
          {
            path: "",
            name: "Manajemen Pegawai",
            meta: {
              title: "Daftar Pegawai",
            },
            component: MasterDataPegawai,
          },
          {
            path: ":id/edit",
            name: "Master Data Pegawai Edit",
            meta: {
              title: "Ubah Pegawai",
            },
            component: MasterDataPegawaiForm,
          },
          {
            path: ":id",
            name: "Master Data Pegawai Detail",
            meta: {
              title: "Detail Pegawai",
            },
            component: MasterDataPegawaiDetail,
          },
          {
            path: ":id/logaktivitas",
            name: "Log Aktivitas Pegawai",
            meta: {
              title: "Log Aktivitas",
              description: "",
              module: "Manajemen Pegawai",
            },
            component: UserAktivitas,
          },
        ],
      },
      {
        path: "/laporan",
        component: Container,
        meta: {
          title: "Laporan"
        },
        redirect: () => {
          return { name: "Laporan Gabungan" };
        },
        children: [
          // gabungan
          {
            path: "laporan-kpi-gabungan",
            name: "Laporan Gabungan",
            meta: {
              title: "Laporan KPI Gabungan",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/laporan-kpi-gabungan/LaporanKpiGabungan.vue'),
          },
          {
            path: "laporan-kpi-gabungan/:kpi_id",
            name: "Laporan Gabungan KPI Detail",
            meta: {
              title: "Laporan KPI Gabungan KPI Detail",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/laporan-kpi-gabungan/LaporanKpiGabunganKpiDetail.vue'),
          },
          {
            path: "laporan-kpi-gabungan/:kpi_id/:sub_kpi_id",
            name: "Laporan Gabungan Sub KPI Detail",
            meta: {
              title: "Laporan KPI Gabungan Sub KPI Detail",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/laporan-kpi-gabungan/LaporanKpiGabunganSubKpiDetail.vue'),
          },
          
          // pegawai
          {
            path: "laporan-kpi-pegawai",
            name: "Laporan Kpi Pegawai",
            meta: {
              title: "Laporan KPI Pegawai",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/laporan-kpi-pegawai/LaporanKpiPegawai.vue'),
          },
          {
            path: "laporan-kpi-pegawai/:employee_id/:realization_id/:periode_id",
            name: "Laporan Kpi Pegawai Detail",
            meta: {
              title: "Laporan KPI Pegawai",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/laporan-kpi-pegawai/LaporanKpiPegawaiDetail.vue'),
          },

          // konsolidasi
          {
            path: "laporan-konsolidasi",
            name: "Laporan Konsolidasi",
            meta: {
              title: "Laporan Konsolidasi",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/laporan-konsolidasi/LaporanKonsolidasi.vue'),
          },
          {
            path: "laporan-summary",
            name: "Laporan Summary",
            meta: {
              title: "Laporan Summary",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/laporan-summary/LaporanSummary.vue'),
          },
          {
            path: "kurva-normal-pegawai",
            name: "Laporan Kurva Normal Pegawai",
            meta: {
              title: "Laporan Kurva Normal Pegawai",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/kurva-normal-pegawai/KurvaNormalPegawai.vue'),
          },
          {
            path: "kurva-normal-cabang",
            name: "Laporan Kurva Normal Cabang",
            meta: {
              title: "Laporan Kurva Normal Cabang",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/kurva-normal-cabang/KurvaNormalCabang.vue'),
          },
          {
            path: "semua-pegawai",
            name: "Laporan Semua Pegawai",
            meta: {
              title: "Laporan Semua Pegawai",
              module: "Laporan"
            },
            component: () => import('@/views/laporan/semua-pegawai/SemuaPegawai.vue'),
          },
        ],
      },
      {
        path: "/tables",
        name: "Tables",
        component: Tables,
      },
      {
        path: "/billing",
        name: "Billing",
        component: Billing,
      },
      {
        path: "/virtual-reality",
        name: "Virtual Reality",
        component: VirtualReality,
      },
      {
        path: "/rtl-page",
        name: "RTL",
        component: RTL,
      },
      {
        path: "/profile",
        name: "Profile",
        component: Profile,
      },
      {
        path: "/manajemen-user",
        component: Container,
        meta: {
          title: "Manajemen User"
        },
        redirect: () => {
          return {
            name: "User",
          };
        },
        children: [
          {
            path: "",
            name: "User",
            meta: {
              title: "Daftar User",
              description: "",
              module: "Manajemen User",
            },
            component: User,
          },
          {
            path: "create",
            name: "User Create",
            meta: {
              title: "Tambah User",
              description: "",
              module: "Manajemen User",
            },
            component: UserForm,
          },
          {
            path: ":id",
            name: "User Single",
            meta: {
              title: "Detail Data User",
              description: "",
              module: "Manajemen User",
            },
            component: UserSingle,
          },
          {
            path: ":id/edit",
            name: "Edit User",
            meta: {
              title: "Ubah User",
              description: "",
              module: "Manajemen User",
            },
            component: UserForm,
          },
          {
            path: ":id/logaktivitas",
            name: "Log Aktivitas User",
            meta: {
              title: "Log Aktivitas",
              description: "",
              module: "Manajemen User",
            },
            component: UserAktivitas,
          },
        ],
      },
    ],
  },
  {
    path: "/manajemen-menu",
    component: Container,
    meta: {
      title: "Manajemen Menu"
    },
    redirect: () => {
      return { name: "Menu" }
    },
    children: [
      {
        path: "",
        name: "Menu",
        meta: {
          title: "Daftar Menu",
          description: "",
          module: "Manajemen Menu",
        },
        component: Menu,
      },
      {
        path: "create",
        name: "Menu Create",
        meta: {
          title: "Tambah Menu",
          description: "",
          module: "Manajemen Menu",
        },
        component: MenuForm,
      },
      {
        path: ":id",
        name: "Menu Edit",
        meta: {
          title: "Ubah Menu",
          description: "",
          module: "Manajemen Menu",
        },
        component: MenuForm,
      },
    ]
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

export default router;
